/* eslint-disable class-methods-use-this */

import { RecurringType } from '@app/common/types/enum/recurringType';
import { TransferType } from '@app/common/types/enum/transferType';

class RecurringsService {
  getItems(allowEndAfterCountOption: boolean, allowEndAfterDateOption: boolean): string[] {
    const types = [
      RecurringType.ENDLESS,
    ];

    if (allowEndAfterDateOption) {
      types.splice(1, 0, RecurringType.END_DATE);
    }

    if (allowEndAfterCountOption) {
      // Seems like we should keep order of options. Need discuss to prevent splice()
      types.splice(1, 0, RecurringType.NUMBER);
    }

    return types;
  }

  isRecurring(value: string | null): value is TransferType {
    const ignoredOptions: string[] = [
      TransferType.SEND_NOW,
      TransferType.ONE_TIME,
      TransferType.SAME_DAY,
    ];

    return !!value && !ignoredOptions.includes(value);
  }

  showStartDate(transferType: TransferType | null): boolean {
    const ignoredOptions: TransferType[] = [
      TransferType.SEND_NOW,
      TransferType.SAME_DAY,
      TransferType.ONE_TIME,
      TransferType.SEMI_MONTHLY,
    ];

    return !!transferType && !ignoredOptions.includes(transferType);
  }

  showFrequency(transferType: TransferType | null): boolean {
    const ignoredOptions: TransferType[] = [
      TransferType.SEND_NOW,
      TransferType.ONE_TIME,
      TransferType.SAME_DAY,
    ];

    return !!transferType && !ignoredOptions.includes(transferType);
  }

  showStartDate12(transferType: TransferType | null): boolean {
    return transferType === TransferType.SEMI_MONTHLY;
  }

  showType(transferType: TransferType | null): boolean {
    const ignoredOptions: TransferType[] = [
      TransferType.SEND_NOW,
      TransferType.ONE_TIME,
      TransferType.SAME_DAY,
    ];

    return !!transferType && !ignoredOptions.includes(transferType);
  }

  showRecurringNumber(recurringType: RecurringType | null): boolean {
    return recurringType === RecurringType.NUMBER;
  }

  showRecurringEndDate(recurringType: RecurringType | null): boolean {
    return recurringType === RecurringType.END_DATE;
  }
}

export default new RecurringsService();
